import { useLayoutEffect, useState } from "react";

// Haklai calc tables keep their column widths. On a narrower section those
// columns used to run off to the left, and the only way to see them was a
// horizontal scroll. Scale the card down to the section instead, anchored
// on the right — the start of an RTL table — so every column stays visible.
export const getHaklaiTableFitScale = (availableWidth, tableWidth) => {
  if (!(availableWidth > 0) || !(tableWidth > 0) || availableWidth + 1 >= tableWidth) return 1;
  return availableWidth / tableWidth;
};

const clearFitStyles = (node) => {
  node.style.width = "";
  node.style.maxWidth = "";
  node.style.marginInline = "";
  node.style.transform = "";
  node.style.transformOrigin = "";
  node.style.marginBottom = "";
};

const useHaklaiTableFit = (frameRef, tableWidth) => {
  const [isFit, setIsFit] = useState(false);

  useLayoutEffect(() => {
    const node = frameRef.current;
    if (!node) return undefined;

    const apply = () => {
      const available = node.parentElement?.clientWidth || 0;
      const scale = getHaklaiTableFitScale(available, tableWidth);
      const fitting = scale < 1;
      setIsFit((prev) => (prev === fitting ? prev : fitting));
      if (!fitting) {
        clearFitStyles(node);
        return;
      }

      // Lay the card out at its real column width, then shrink that box
      // toward the right edge. The negative margin drops the empty layout
      // space the unscaled height would leave under the visual table.
      node.style.width = `${tableWidth}px`;
      node.style.maxWidth = "none";
      node.style.marginInline = "0";
      node.style.transformOrigin = "top right";
      node.style.transform = `scale(${scale})`;
      node.style.marginBottom = `${-Math.round(node.offsetHeight * (1 - scale))}px`;
    };

    apply();
    const parent = node.parentElement;
    const observer = typeof ResizeObserver === "undefined" || !parent
      ? null
      : new ResizeObserver(apply);
    if (observer) observer.observe(parent);
    window.addEventListener("resize", apply);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", apply);
      clearFitStyles(node);
    };
  }, [frameRef, tableWidth]);

  return isFit;
};

export default useHaklaiTableFit;
